import { VStack } from '@chakra-ui/react';
import { Bookmark, Forward, Heart } from 'lucide-react';
import useContentReactions from '@/hooks/content/useContentReactions';
import RailButton from '@/modules/content/loop/parts/RailButton';
import { TContent } from '@/types/Content.types';

// The loop's action rail, sitting alongside the media. Drives off the same shared
// reactions module as the cards and the article page, so a like here shows up there too.
const FocusedLoopRail = ({ content }: { content: TContent }) => {
  const { liked, saved, toggleLike, toggleSave, share } = useContentReactions(content);

  // Posts and videos have no standalone page — a shared link opens the loop anchored at
  // the item, where they render in full. Only used if the backend share call fails.
  const shareUrl = `${window.location.origin}/loop/${content.id}`;

  return (
    <VStack gap="14px" align="center" flexShrink={0}>
      <RailButton icon={Heart} label={liked ? 'Liked' : 'Like'} active={liked} onClick={toggleLike} />
      <RailButton icon={Bookmark} label={saved ? 'Saved' : 'Save'} active={saved} onClick={toggleSave} />
      <RailButton icon={Forward} label="Share" onClick={() => share(shareUrl)} />
    </VStack>
  );
};

export default FocusedLoopRail;
